import { forwardRef, type Ref, type SVGProps } from "react";
const IconPharmacyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M23.78 8.22a1 1 0 1 0-1.413 1.415c.314.314.392 1.022-.177 1.59l-2.652 2.652a1 1 0 0 0 1.415 1.415l2.651-2.652c1.189-1.189 1.425-3.172.177-4.42z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25.899 14.588a6.004 6.004 0 0 0-8.245-8.726l-.01.01q-.12.108-.236.225L6.1 17.404a6.004 6.004 0 1 0 8.492 8.491zm-1.414-1.414-4.947 4.946-5.656-5.657 5.135-5.135a4.005 4.005 0 0 1 5.468 5.846m-16.97 5.644 4.946-4.947 5.663 5.663-4.946 4.947a4.004 4.004 0 0 1-5.663-5.663"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPharmacyOutlineSVG);
ForwardRef.displayName = "IconPharmacyOutline";
export { ForwardRef as IconPharmacyOutline };
